let clevertapInstance = null;

export const getClevertap = async () => {
  if (!clevertapInstance) {
    const mod = await import("clevertap-web-sdk");
    mod.default.init(process.env.REACT_APP_CLEVERTAP_PROJECT_ID, "in1");
    mod.default.setLogLevel(3);
    clevertapInstance = mod.default;
    window.clevertap = clevertapInstance;
  }
  return clevertapInstance;
};

export const pushCleverTapEvent = async (eventName, eventData = {}) => {
  try {
    const clevertap = await getClevertap();
    clevertap.event.push(eventName, eventData);
    console.log(`CleverTap event "${eventName}" pushed.`, eventData);
  } catch (err) {
    console.error("CleverTap push event failed:", err);
  }
};

export const identifyCleverTapUser = async (user) => {
  try {
    const clevertap = await getClevertap();
    clevertap.onUserLogin.push({
      Site: {
        Identity: user.id,
        Name: user.name,
        Email: user.email,
        Phone: user.phone,
        Gender: user.gender,
        DOB: user.dob,
        ...user // pass any custom props like city, platform, etc.
      }
    });

    console.log("CleverTap user identified:", user);
  } catch (err) {
    console.error("Failed to identify CleverTap user:", err);
  }
};
